import { VerbFetch } from '../VerbFetch';

export const imageUpload = (pathsContext, img) => () => {
    const params = {
        method: 'POST',
        body: {
            name: img.name,
            type: img.type,
            bucket: 'images'
        }
    };
    return VerbFetch(`${pathsContext.mediaLibraryUrl}/upload`, params)
        .then((result) => {
            const { uploadURL } = result;
            return fetch(uploadURL, {
                method: 'PUT',
                body: new Blob([img.file], { type: img.type })
            });
        })
        .then(() => {
            const s3Url = `s3://${pathsContext.imagesBucket}/${img.name}`;
            const imageParams = {
                method: 'POST',
                body: {
                    url: s3Url
                }
            };
            return VerbFetch(`${pathsContext.serverUrl}/imageupload`, imageParams);
        })
        .then((result) => result)
        .catch((err) => {
            throw new Error(err);
        });
};
